export default "__VITE_ASSET__7ae45149__"